import './password-field.scss';
import classNames from 'classnames';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Case, Default, Switch,
} from 'react-if';
import { Link } from 'react-router-dom';
import { ReactComponent as ShowPasswordSvg } from '../../../../assets/svgs/show-password.svg';
import { ReactComponent as HidePasswordSvg } from '../../../../assets/svgs/hide-password.svg';

const PasswordField = ({
  name, label, variant, placeholder, link,
}) => {
  const { control } = useFormContext();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <div className="form-control">
      <label htmlFor={name} className="form-control__label">
        {label}
      </label>
      <Controller
        render={({ field, fieldState }) => (
          <>
            <div className="form-control__password">
              <input
                {...field}
                id={name}
                type={isPasswordVisible ? 'text' : 'password'}
                className={classNames('form-control__input', {
                  'has-error': !!fieldState.error,
                })}
                readOnly={variant === 'link'}
                placeholder={placeholder}
                autoComplete="off"
                data-testid={name}
              />
              <Switch>
                <Case condition={variant !== 'link' && !isPasswordVisible}>
                  <button
                    className="form-control__password__btn"
                    type="button"
                    onClick={() => setIsPasswordVisible(true)}
                    aria-label="Hide or Show Password Button"
                  >
                    <ShowPasswordSvg />
                  </button>
                </Case>
                <Case condition={variant !== 'link' && isPasswordVisible}>
                  <button
                    className="form-control__password__btn"
                    type="button"
                    onClick={() => setIsPasswordVisible(false)}
                    aria-label="Hide or Show Password Button"
                  >
                    <HidePasswordSvg />
                  </button>
                </Case>
                <Case condition={variant === 'link'}>
                  <Link
                    className="form-control__password__btn form-control__password__edit-btn"
                    to={link}
                  >
                    Edit
                  </Link>
                </Case>
                <Default />
              </Switch>
            </div>
            {fieldState.error && (
              <span className="form-control__error">
                {fieldState.error.message}
              </span>
            )}
          </>
        )}
        control={control}
        name={name}
      />
    </div>
  );
};

export default PasswordField;
